export default __webpack_public_path__ + "static/blog-ada038914ffeaaf41706870fc0f8d074.png";